export default __webpack_public_path__ + "static/media/freya-node-gold.ff471a76.svg";